import { NORMAL } from '../constants';
import { parseUnit } from '../util/misc/svgParsing';
import { reFontDeclaration } from './constants';

/**
 * Parses a short font declaration, building adding its properties to a style object
 * @param {String} value font declaration
 * @param {Object} oStyle definition
 */
export function parseFontDeclaration(
  value: string,
  oStyle: Record<string, any>,
): void {
  const match = value.match(reFontDeclaration);

  if (!match) {
    return;
  }
  const fontStyle = match[1],
    // font variant is not used
    // fontVariant = match[2],
    fontWeight = match[3],
    fontSize = match[4],
    lineHeight = match[5],
    fontFamily = match[6];

  if (fontStyle) {
    oStyle.fontStyle = fontStyle;
  }
  if (fontWeight) {
    oStyle.fontWeight = isNaN(parseFloat(fontWeight))
      ? fontWeight
      : parseFloat(fontWeight);
  }
  if (fontSize) {
    oStyle.fontSize = parseUnit(fontSize);
  }
  if (fontFamily) {
    oStyle.fontFamily = fontFamily;
  }
  if (lineHeight) {
    oStyle.lineHeight = lineHeight === NORMAL ? 1 : lineHeight;
  }
}
